/*-----------------------------------------------------------------
- Theme global mixin
-----------------------------------------------------------------*/
import Vue from 'vue';
import { get } from 'lodash/object';

Vue.mixin({
    name: 'ThemeMixin',

    methods: {
        /**
         * Get menu by slug from the Vuex store.
         *
         * @param {string} slug
         * @returns {*}
         */
        getMenu(slug) {
            return this.$store.getters['menu/get'](slug.replace('$', this.$i18n.locale));
        },

        /**
         * Return router-link object
         *
         * @param {string} name
         * @param {object} post
         * @returns {object}
         */
        routeTo(name, post) {
            const params = {};
            if (post && post.url_encode) {
                params.url_encode = post.url_encode;
            } else if (post && post.id) {
                params.id = post.id;
            }

            return {
                name,
                params,
            };
        },

        /**
         * Return best version of image
         *
         * @param {object|Array} img
         * @param {string} imageVersion
         * @returns {string}
         */
        imgSrc(img, imageVersion) {
            if(!img) {
                return img;
            }

            if (Array.isArray(img)) {
                return get(img, `0.versions.${imageVersion}`, get(img, '0.link', ''));
            }
            return get(img, `versions.${imageVersion}`, get(img, 'link', ''));
        }
    },
});
